<template>
  <div>
    <div class="upload-img" v-show="!toSubmit">
      <div class="content-wrapper">
        <div class="upload-img-header">
          <img-v3 :src="pics[0]" :class="{widthImg:pic_type==1,heightImg:pic_type==2}" />
        </div>
        <div class="upload-img-content">
          <p class="content-title">{{sample.title}}</p>
          <p class="content-p" v-for="(t,idx) in sample.content" :key="idx" v-html="t"></p>
        </div>
      </div>
      <div class="upload-input-wrapper">
        <div :class="['out-upload-input', `${country}-out-upload-input`]">
          <input type="button" @click="selectImg" />
          {{$t('img.take_photo')}}
        </div>
      </div>
    </div>
    <div class="reUpload-img" v-show="toSubmit">
      <div class="reUpload-img-header">
        <div
          v-show="field_status!=6&&field_result&&showTip"
          class="tips"
          :class="[{success:field_status ==AUDIT_STATUS.success,checking:field_status ==AUDIT_STATUS.in || field_status ==AUDIT_STATUS.noSubmit ,error:field_status ==AUDIT_STATUS.fail}]"
        >{{field_result}}</div>
         <template v-if="inApp && !inPassengerTerminal">
          <img-v3 :src="uploadImgSrc" />
        </template>
        <template v-else>
          <croppa
            ref="imgCroppa"
            v-model="croppa"
            :width="270"
            :height="270"
            placeholder
            class="croppaImg"
            :disabled="false"
            :initial-image="uploadImgSrc"
            initial-size="cover"
            :prevent-white-space="true"
            :show-remove-button="false"
            @file-choose="handleCroppaFileChoose"
          ></croppa>
        </template>
      </div>
      <div class="bottom-area" v-show="!hideBottom">
        <a :class="['btn-submit', `${country}-submit`]" @click="uploadImg" v-if="canSubmit">{{$t("img.submit_btn_txt")}}</a>
        <a :class="['btn-reUpload', `${country}-reUpload`]" @click="clearImg">{{$t("img.reUpload_btn_txt")}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import scale from "./Scale";
import { post } from "../../tools/request";
import { showLoadingToast, showAlertDialog } from "../../tools/Tip";
import { ends } from "../../tools/constant";

const AUDIT_STATUS = {
  in: 3,
  success: 4,
  fail: 5,
  noSubmit: 0,
  beforeUpdate: 6
};

export default {
  name: "upload-photo",
  data() {
    return {
      toSubmit: false, //页面模块控制
      canSubmit: false, //提交按钮控制,
      showTip: true, //默认为true，点击重新上传后不再展示
      uploadImgSrc: "",
      croppa: {},
      croppaLoop: null,
      croppaHasImage: false,
      uploadStart: 0,
      originSize: 0,
      compressedSize: 0,
    };
  },
  computed: {
    ...mapState(["_ticket", "_uuid"]),
    AUDIT_STATUS() {
      return AUDIT_STATUS;
    },
    deviceInfo() {
      return {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
      };
    },
    //传递过来整个对象
    formItem() {
      let c = this.$route.params.configs;
      return c || {};
    },
    pics() {
      return this.formItem.exam_pic_url || [];
    },
    pic_type() {
      return this.formItem.exam_pic_type || 1;
    },
    sample() {
      return this.formItem.pic_desc || {};
    },
    field_status() {
      return this.formItem.field_status || 0;
    },
    field_result() {
      return this.formItem.field_result || "";
    },
    //上传成功态，隐藏底部按钮
    hideBottom() {
      return this.field_status == AUDIT_STATUS.success;
    },
    inApp() {
      return !!Fusion.pickImage;
    },
    inPassengerTerminal() {
      return ends.isPassengerTerminal;
    },
    country() {
      let up = new URLSearchParams(location.search)
      return up.get('location_country')
    },
    document_enum() {
      return this.formItem.document_enum || "";
    }
  },

  beforeCreate() {
    //一旦进入上传页，返回按钮就正常返回
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 2
      });
  },
  created() {
    //非nosubmit，展示上传区域、传过的图片
    if (
      this.field_status != AUDIT_STATUS.noSubmit &&
      this.field_status != AUDIT_STATUS.beforeUpdate
    ) {
      this.toSubmit = true;
      this.uploadImgSrc = this.formItem.value[0] || "";
    }
  },
  methods: {
    handleCroppaFileChoose() {
      this.$nextTick(() => {
        this.clearCroppaInterval();
        this.croppaHasImage = this.$refs.imgCroppa.hasImage();
        this.croppaLoop = setInterval(() => {
          if (this.croppaHasImage) {
            this.uploadImgSrc = this.$refs.imgCroppa.generateDataUrl();
            this.originSize = this.uploadImgSrc ? this.uploadImgSrc.originSize : 0;
            this.compressedSize = this.uploadImgSrc ? this.uploadImgSrc.length : 0;
            this.canSubmit = true;
            this.toSubmit = true;
            //通知父级组件重新渲染
            this.$emit("btn-update");
            this.clearCroppaInterval();
          } else {
            this.croppaHasImage = this.$refs.imgCroppa ? this.$refs.imgCroppa.hasImage() : false;
          }
        }, 200);
      });
    },
    clearCroppaInterval() {
      if (this.croppaLoop) {
        clearInterval(this.croppaLoop);
        this.croppaLoop = null;
      }
    },

    //采用澳洲方案，先传图片，再提审
    uploadImg() {
      this.uploadStart = +new Date();
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let success = data => {
        this.toast.hide();
        if (data.low_quality_res && data.low_quality_res === 1) {
          showAlertDialog(this, data.low_quality_des);
          return false;
        }
        this.submitImg(data.img_id);
        Omega.trackEvent("upload_success", "", {
          duid: this._uuid,
          app_upload: this.inApp,
          wait_time: new Date() - this.uploadStart,
          cut: true,
          origin_size: this.originSize,
          compressed_size: this.compressedSize
        });
      };
      up.append("__x_img", this.inApp && !this.inPassengerTerminal ? this.uploadImgSrc : this.$refs.imgCroppa.generateDataUrl());
      up.append("type", this.formItem.key);
      up.append("document_enum", this.document_enum);
      
      post(process.env.UPLOAD_IMG, up)
        .then(success)
        .catch(this.httpError);
    },
    submitImg(url) {
      let up = new URLSearchParams(location.search);
      up.append(this.formItem.key, JSON.stringify([url]));
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      // @20190213 支持任务中心,type|uid
      if (this.formItem.job_type) {
        up.append("job_type", this.formItem.job_type);
      }
      if (this.formItem.job_uid) {
        up.append("job_uid", this.formItem.job_uid);
      }
      let success = data => {
        this.$router.replace({ name: "home" });
      };
      post(process.env.ADD_AUDI_INFO, up)
        .then(success)
        .catch(err => {
          this.httpError(err);
          try {
            Omega.trackEvent("ibt_register_submit_review_error_ck", '', {
              path_url: process.env.ADD_AUDI_INFO,  //接口url
              message: JSON.stringify(err),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: err.errno,  //报错码
            });
          } catch (e) {}
        });
      Omega.trackEvent("gd_oasisPreviewCertificates_submit_ck", "", {
        type: this.formItem.key
      });
    },
    clearImg() {
      this.canSubmit = false;
      this.toSubmit = false;
      this.showTip = false;
      this.uploadImgSrc = "";
      this.$emit("btn-update");
      Omega.trackEvent("gd_oasisPreviewCertificates_reupload_ck", "", {
        type: this.formItem.key
      });
    },
    selectImg() {
      let up = new URLSearchParams(location.search);
      let country = up.get('location_country');
      if (this.inApp && !this.inPassengerTerminal) {
        const isAndroid = /(Android)/i.test(navigator.userAgent);
        if (isAndroid) {
          Fusion && Fusion.pickImage({source:-1} , ()=>{})
        }
        if (Fusion && Fusion.chooseImage) {
          Fusion.chooseImage(
            {
              source: ["CL", "AR"].includes(country) ? 2 : 3,
              quailty: 100,
              editable: true,
              width: 710,
              height: 710,
              scene: /(Android)/i.test(navigator.userAgent) ? 2 : 3, //2头像照, 1证件照, 3新加ios上传头像(流程和Android2一致)(新加)
              camera_title: this.$t("GDriver_picture_Line_box_OsdL"), //拍照上方文案
              image_editor_title: this.$t("GDriver_picture_View_frame_usSJ"), // 裁剪上方文案
              is_show_camera_mask: true, // 使用蒙层
              is_hide_camera_local_title: true, // 拍照上方文案使用配置
              is_hidden_image_editor_local_title: true, // 裁剪上方文案使用配置
            },
            ret => this.handleAfterChoose(ret)
          );
        }
      } else {
        this.$refs.imgCroppa.$refs.fileInput.setAttribute("accept", "image/*");
        this.$refs.imgCroppa.chooseFile();
      }
      Omega.trackEvent("gd_oasisUploadCertificates_confirm_ck", "", {
        type: this.formItem.key
      });
    },
    handleAfterChoose(ret) {
      if (this.inApp && !this.inPassengerTerminal) {
        const isAndroid = /(Android)/i.test(navigator.userAgent);
        if (isAndroid) {
          Fusion && Fusion.chooseImage({source:-1}, ()=>{})
        }
      }
      if (!ret) {
        this.httpError();
        return;
      }
      let imgSrc = ret.image;
      if (this.inApp && !this.inPassengerTerminal) {
        imgSrc = "data:image/jpeg" + ";base64," + ret.image;
      }
      this.uploadImgSrc = imgSrc;
      this.canSubmit = true;
      this.toSubmit = true;
      //埋点用
      this.compressedSize = imgSrc.length;
      this.originSize = ret.originSize || 0;
      //通知父级组件重新渲染
      this.$emit("btn-update");
      //@20191118 自动提交
      Omega.trackEvent("gd_oasisPreviewCertificates_sw", "", {
        type: this.formItem.key
      });
    },
    handleImageError() {
      showAlertDialog(this, this.$t("图片尺寸过大"));
    },
    httpError(res) {
      try {
        Omega.trackEvent("upload_fail", "", {
          duid: this._uuid,
          app_upload: this.inApp,
          wait_time: new Date() - this.uploadStart,
          cut: true,
          origin_size: this.originSize,
          compressed_size: this.compressedSize,
          msg: res.errmsg || res.message
        });
      } catch (e) {}
      this.toast.hide();
      showAlertDialog(this, this.$t("ERROR_DEFAULT_TEXT"));
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-img {
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 2rem;
  .upload-img-header {
    height: 6.12rem;
    background: #282a33;
    overflow: hidden;
    position: relative;
    .widthImg {
      width: 5.4rem;
      height: 5.4rem;
      background-size: 5.4rem 5.4rem;
    }
    .heightImg {
      width: 3.84rem;
      height: 5.2rem;
      background-size: 3.84rem 5.2rem;
    }
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .upload-img-content {
    text-align: center;
    padding: 0.3rem 0.32rem 0;
    .content-title {
      font-size: 0.48rem;
      color: #1f2933;
      margin-bottom: 0.24rem;
    }
    .content-p {
      text-align: left;
      font-size: 0.28rem;
      color: #949494;
      margin-bottom: 0.2rem;
      line-height: 1.1;
    }
  }

  .upload-input-wrapper {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    background: #f5f5f7;
    .out-upload-input {
      position: relative;
      margin: 0.4rem auto;
      display: block;
      width: 6.8rem;
      height: 1.08rem;
      font-size: 0.32rem;
      line-height: 1.08rem;
      text-align: center;
      font-family: "HelveticaNeue-Medium";
      color: #fff;
      background: linear-gradient(45deg, #ff5b1d, #ff7f41);
      border-radius: 6px;
      &.BR-out-upload-input {
        color: #000;
        background: #ffe600;
      }
      > input {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
      }
    }
  }
}

.reUpload-img {
  .reUpload-img-header {
    background: #282a33;
    overflow: hidden;
    position: relative;
    height: 5.88rem;
    img {
      max-width: 90%;
      height: 5.44rem;
      display: block;
      margin: 0.24rem auto;
    }
    .croppaImg {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .tips {
      padding: 0.36rem 0.3rem;
      color: #fff;
      font-size: 0.32rem;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 10;
      box-sizing: border-box;
      width: 100%;
      opacity: 0.9;
      &.success {
        background: #18C47C;
      }
      &.error {
        background: #ff4d58;
      }
      &.checking {
        display: none;
        background: #999;
      }
    }
  }
  .bottom-area {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    z-index: 5;
    padding: 0.36rem 0.32rem;
    > a {
      display: block;
      &.btn-submit {
        width: 6.8rem;
        height: 1.08rem;
        font-size: 0.32rem;
        line-height: 1.08rem;
        text-align: center;
        font-family: "HelveticaNeue-Medium";
        color: #fff;
        background: linear-gradient(45deg, #ff5b1d, #ff7f41);
        border-radius: 6px;
        &.BR-submit {
          color: #000;
          background: #ffe600;
        }
      }
      &.btn-reUpload {
        width: 6.8rem;
        height: 1.08rem;
        font-size: 0.32rem;
        line-height: 1.08rem;
        text-align: center;
        font-family: "HelveticaNeue-Medium";
        color: #ff7226;
        background: #fff;
        border: 1px solid #ff7226;
        border-radius: 6px;
        &.BR-reUpload {
          color: #333;
          background: #fff;
          border: 1px solid #999;
        }
      }
      &:first-child {
        margin-bottom: 0.2rem;
      }
    }
    
  }
}
</style>
